module.exports = __webpack_public_path__ + "static/top-7f80b2300ade8c8fd6241f51543b0dad.png";